import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RetailOrderContext } from "../../retail-order/context/RetailOrderContext";

export default function MaterialOrderBackButton() {

	const navigate = useNavigate();
	let [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const { order } = useContext(RetailOrderContext);

	return (
		<Button
			text="Back"
			icon="Inscyth-Back"
			elementAttr={{ 'data-testid': 'btn-back' }}
			visible={order.details.materialOrders.length > 0}
			onClick={() =>
				navigate(`/cfi/retail-order/${order.details.retailOrderID}/130` + (!!returnUrl ? '?returnUrl=' + returnUrl : ''))
			} >
		</Button>
	)
}
